// React
import React, { useState, useEffect, useCallback } from "react";

// Kendo
import kendo from "@progress/kendo-ui";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Checkbox } from "@progress/kendo-react-inputs";

// Css
import "./elderDisease.css"
import styles from "./elderDisease.module.css"

// Service
import { getUser, isAdmin, isDeveloper, isLogin } from "../../../service/authService";
import { getDiseaseList, getUserDiseaseList, updateUserDisease } from "../../../service/mngt/elderService";
import { parseDate } from "../../../com/dateUtil";

// Component
import { Delete } from "@material-ui/icons";

const ElderDiseaseEdit = ({ conn, elderInfo, setElderInfo, getUserDiseaseListCallback }) => {
  
  const userInfo = getUser();

  // 데이터 저장
  const [data, setData] = useState({
    diseaseDefault: { diseaseTerm: "지병 선택" , diseaseCode: null },
    disease: null,
    diseaseList: [],
  })
  const [diseaseValue, setDiseaseValue] = useState({  diseaseTerm: elderInfo.selectedRow.dataItem.diseaseTerm , diseaseCode: elderInfo.selectedRow.dataItem.diseaseCode })

  // 데이터 상태
  const [dataState, setDataState] = useState({
    userId: elderInfo.dataItem.userId,
    diseaseCode: elderInfo.selectedRow.dataItem.diseaseCode,
    diseaseTerm: elderInfo.selectedRow.dataItem.diseaseTerm,
    diseaseTermOther: elderInfo.selectedRow.dataItem.diseaseTermOther,
    medicationYn: elderInfo.selectedRow.dataItem.medicationYn,
    medicationNote: elderInfo.selectedRow.dataItem.medicationNote,
    editId: userInfo.userId,
    editDtm: parseDate("yyyy-mm-dd hh:mm:ss", new Date()),
  })


  // 행동패턴 저장
  const saveDisease = () => {
    if (dataState.diseaseCode === null || dataState.diseaseTerm === null) {
      kendo.alert("지병을 선택해주세요.");
    } else if (dataState.diseaseTerm === "기타" && dataState.diseaseTermOther === null) {
      kendo.alert("지병을 입력해주세요.");
    } else if (dataState.medicationYn === null) {
      kendo.alert("투약여부를 선택해주세요.");
    } else {
      updateUserDisease(conn, dataState)
      .then(() => {
        kendo.alert("저장이 완료되었습니다.");
        getUserDiseaseList(conn, getUserDiseaseListCallback, getRejection, dataState);
        closeEvt();
      })
      .catch((error) => {
        kendo.alert("중복된 데이터가 있습니다.")
        getUserDiseaseList(conn, getUserDiseaseListCallback, getRejection, dataState);
        closeEvt();
        console.log("error ", error);
      })

    }
  }

  // 닫기 이벤트
  const closeEvt = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.diseaseEditInfo = false;
      return item;
    });
  };

  const getDiseaseListCallback = result => {
    setData((data) => {
      const item = { ...data };
      item.diseaseList = result;
      return item;
    })
  }

  const getRejection = reject => {
    console.log("getRejection = ", reject);
  };


  // 보유지병 선택
  const handleChangeDisease = event => {
    setDiseaseValue({ diseaseCode: event.target.value.diseaseCode, diseaseTerm: event.target.value.diseaseTerm})
    dataState.diseaseCode = event.target.value.diseaseCode;
    dataState.diseaseTerm = event.target.value.diseaseTerm;
    
  }

  // 보유지병 기타
  const diseaseTermOtherChange = event => {
    setDataState((dataState) => {
      const item = { ...dataState };
      item.diseaseTermOther = event.target.value;
      return item;
    })
  }



  // 투약 여부
  const [checked, setChecked] = useState({
    checkedY: false,
    checkedN: false,
  })

  const handleChangeY = () => {
   
    setChecked(checked => {
      const item = { ...checked };
      item.checkedY = !checked.checkedY;
      return item;
    })
    if (checked.checkedN) {
      setChecked(checked => {
        const item = { ...checked };
        item.checkedN = false;
        return item;
      })
    }
    if (!checked.checkedY) {
      setDataState(dataState => {
        const item = { ...dataState };
        item.medicationYn = 'Y';
        return item;
      })
    } else {
      setDataState(dataState => {
        const item = { ...dataState };
        item.medicationYn = null;
        return item;
      })
      setData((data) => {
        const item = { ...data };
        item.diseaseList = [];
        return item;
      })
    }
  };

  const handleChangeN = () => {
    setChecked(checked => {
      const item = { ...checked };
      item.checkedN = !checked.checkedN;
      return item;
    })
    setDataState(dataState => {
      const item = { ...dataState };
      item.medicationYn = null;
      item.medicationNote = null
      return item;
    })
    if (checked.checkedY) {
      setChecked(checked => {
        const item = { ...checked };
        item.checkedY = false;
        return item;
      })
    }
    if (!checked.checkedN) {
      setDataState(dataState => {
        const item = { ...dataState };
        item.medicationYn = 'N';
        return item;
      })
    } else {
      setData((data) => {
        const item = { ...data };
        item.diseaseList = [];
        return item;
      })
    }
  };

  const medicationNoteChange = (event) => {
    setDataState((dataState) => {
      const item = { ...dataState };
      item.medicationNote = event.target.value;
      return item;
    })
  }

  
  useEffect(() => {
    getDiseaseList(conn, getDiseaseListCallback, getRejection, dataState);
    if(elderInfo.selectedRow.dataItem.medicationYn === "Y") {
      setChecked(checked => {
        const item = { ...checked };
        item.checkedY = true;
        return item;
      })
    } else if(elderInfo.selectedRow.dataItem.medicationYn === "N") {
      setChecked(checked => {
        const item = { ...checked };
        item.checkedN = true;
        return item;
      })
    }
  }, []);


  return (
    <Dialog title={"지병 수정"} onClose={closeEvt}>
      <div className={styles.diseaseAddDialog}>
        <span className={styles.medicationYn}>지병</span>
        <div className={styles.category}>
          <DropDownList
            className={styles.diseaseListDropdown}
            data={data.diseaseList}
            textField = "diseaseTerm" 
            dataItemKey="diseaseCode"
            defaultItem={data.diseaseDefault}
            // disabled={data.diseaseList.length === 0 && checked.checkedY === false && checked.checkedN === false}
            onChange={handleChangeDisease}
            value={diseaseValue}
            disabled={true}
          />
        </div>
        {dataState.diseaseTerm === "기타" &&
          <div className={styles.category}>
            <input className={styles.diseaseTermOtherInput} type="text" value={dataState.diseaseTermOther} onChange={diseaseTermOtherChange} placeholder="EX) 고혈압, 당뇨 등" />
          </div>
        }
        <div className={styles.category}>
          <span className={styles.medicationYn}>투약 여부</span>
          <Checkbox className={styles.medicationYnCheckbox} label="Y" checked={checked.checkedY} onChange={handleChangeY} />
          <Checkbox className={styles.medicationYnCheckbox} label="N" checked={checked.checkedN} onChange={handleChangeN} />
        </div>
        {dataState.medicationYn === "Y" &&
          <div className={styles.category}>
            <input className={styles.medicationNoteInput} type="text" value={dataState.medicationNote} onChange={medicationNoteChange} placeholder="EX) 일 2회 아침 식후, 저녁 식후" />
          </div>
        }
        <div className={styles.categoryButton}>
          <Button onClick={saveDisease}>수정</Button>
          <Button onClick={closeEvt}>취소</Button>
        </div>
      </div>
    </Dialog>
  );
};
export default ElderDiseaseEdit;
